import { Grid } from "@mui/material";
import { theme } from "../../common/utils/theme";

export const topBar = {
  backgroundColor: theme.palette.primary.main,
};

const AuthLayout = (props: React.PropsWithChildren) => {
  return (
    <Grid container height={"100vh"}>
      <Grid
        border={"px solid red"}
        container
        flex={1.1}
        justifyContent={"center"}
        alignItems={"center"}
        overflow={"auto"}
      >
        {props.children}
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
